/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelTipoPraticaAttributoDTO } from '../model/models';
import { TipoPraticaAttributoCreationForm } from '../model/models';
import { TipoPraticaAttributoDTO } from '../model/models';
import { TipoPraticaAttributoListFilter } from '../model/models';
import { TipoPraticaAttributoPatchForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CreateTipoPraticaAttributoRequestParams {
    idTipoPratica: string;
    tipoPraticaAttributoCreationForm: TipoPraticaAttributoCreationForm;
}

export interface DeleteTipoPraticaAttributoRequestParams {
    idTipoPratica: string;
    idAttr: string;
}

export interface GetTipoPraticaAttributoRequestParams {
    idTipoPratica: string;
    idAttr: string;
}

export interface ListTipoPraticaAttributiRequestParams {
    idTipoPratica: string;
    filter: TipoPraticaAttributoListFilter;
    pageable: Pageable;
}

export interface UpdateTipoPraticaAttributoRequestParams {
    idTipoPratica: string;
    idAttr: string;
    tipoPraticaAttributoPatchForm: TipoPraticaAttributoPatchForm;
}


export interface TipoPraticaAttributoControllerServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Crea un nuovo attributo dichiarato dal TipoPratica (3 assi: field/component/validation)
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi
* @param requestParameters
     */
    createTipoPraticaAttributo(requestParameters: CreateTipoPraticaAttributoRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaAttributoDTO>;

    /**
     * Elimina un attributo dichiarato dal TipoPratica (cascade ai valori catalogati)
     * 
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi/{idAttr}
* @param requestParameters
     */
    deleteTipoPraticaAttributo(requestParameters: DeleteTipoPraticaAttributoRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Dettaglio di un attributo per id (include \&#39;valori\&#39; inline per CUSTOM_SINGLE_CHOICE/CUSTOM_MULTIPLE_CHOICE)
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi/{idAttr}
* @param requestParameters
     */
    getTipoPraticaAttributo(requestParameters: GetTipoPraticaAttributoRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaAttributoDTO>;

    /**
     * Lista paginata degli attributi del TipoPratica (filtri: target, binding_target, ui_widget, obbligatorio, q)
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi
* @param requestParameters
     */
    listTipoPraticaAttributi(requestParameters: ListTipoPraticaAttributiRequestParams, extraHttpRequestParams?: any): Observable<PagedModelTipoPraticaAttributoDTO>;

    /**
     * Replace di un attributo (richiede version per optimistic lock; chiave/binding_target frozen post-pubblicazione)
     * 
     * @endpoint put /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi/{idAttr}
* @param requestParameters
     */
    updateTipoPraticaAttributo(requestParameters: UpdateTipoPraticaAttributoRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaAttributoDTO>;

}
